import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { setUserData } from '../../util/manageUserData';

@Component({
  selector: 'app-o-auth',
  templateUrl: './o-auth.component.html',
  styleUrls: ['./o-auth.component.css'],
})
export class OAuthComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  message = 'Please wait we are verifying your token...';
  ngOnInit(): void {
    console.log('Login with Oauth');
    this.loginWithOAuth();
  }

  loginWithOAuth() {
    console.log('Login with Oauth Function');
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['code']) {
        this.authService
          .loginForPandG(params['code'])
          .then((res) => {
            if (res['success'] === '1') {
              setUserData(res['data']);
              let project_key = environment.client_env;
              let homeRoute = environment[project_key]['home_route'];

              if (homeRoute) {
                this.router.navigateByUrl(homeRoute);
              } else {
                this.router.navigateByUrl('/sd');
              }
            } else {
              this.router.navigateByUrl('/login');
            }
          })
          .catch((err) => {});
      } else {
        this.message = 'Something Went wrong.';
      }
    });
  }

  getBearerToken(code: string) {
    this.authService
      .getPINGBeareToken(code)
      .toPromise()
      .then((res) => {
        this.router.navigateByUrl('/footfalls');
      })
      .catch((err) => {
        this.router.navigateByUrl('/login');
      });
  }
}
